import { useCallback, useMemo, useState } from 'react'
import type { SubmitFeedback, UploadFeedbackAttachment } from '@/modules/feedback/use-cases'
import { FeedbackDialog } from '../components'
import { FeedbackDialogContext } from './feedback-dialog-context'

type FeedbackDialogProviderProps = {
  onSubmitFeedback: SubmitFeedback
  onUploadFeedbackAttachment: UploadFeedbackAttachment
  children: React.ReactNode
}

export function FeedbackDialogProvider({
  onSubmitFeedback,
  onUploadFeedbackAttachment,
  children,
}: FeedbackDialogProviderProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [refreshToken, setRefreshToken] = useState(0)

  const openDialog = useCallback(() => setIsOpen(true), [])
  const closeDialog = useCallback(() => setIsOpen(false), [])
  const notifySubmitted = useCallback(() => setRefreshToken((token) => token + 1), [])

  const value = useMemo(
    () => ({
      isOpen,
      openDialog,
      closeDialog,
      onSubmitFeedback,
      onUploadFeedbackAttachment,
      refreshToken,
      notifySubmitted,
    }),
    [
      isOpen,
      openDialog,
      closeDialog,
      onSubmitFeedback,
      onUploadFeedbackAttachment,
      refreshToken,
      notifySubmitted,
    ],
  )

  return (
    <FeedbackDialogContext.Provider value={value}>
      {children}
      <FeedbackDialog />
    </FeedbackDialogContext.Provider>
  )
}
